import { SearchStrategy, SearchStrategyProps, SearchResult } from './SearchStrategy';
import { DefaultSearchStrategy } from './DefaultSearchStrategy';
import { MilitaryBaseSearchStrategy } from './MilitaryBaseSearchStrategy';
import { CombinedSearchStrategy } from './CombinedSearchStrategy';

/**
 * Search strategy specifically for the in-service tenant.
 * Uses CombinedSearchStrategy to combine regular location search with military base search.
 */
export class InServiceSearchStrategy implements SearchStrategy {
  private combinedStrategy: CombinedSearchStrategy;

  constructor() {
    // Create the individual strategies
    const defaultStrategy = new DefaultSearchStrategy();
    const militaryBaseStrategy = new MilitaryBaseSearchStrategy();
    
    // Use the strategy combiner to handle parallelization
    this.combinedStrategy = new CombinedSearchStrategy([
      defaultStrategy,
      militaryBaseStrategy,
    ]);
  }

  async search(props: SearchStrategyProps): Promise<SearchResult> {
    try {
      // Delegate to the combined strategy for parallel execution
      return await this.combinedStrategy.search(props);
    } catch (err) {
      console.error('[InServiceSearchStrategy] Error:', err);
      return {
        searchPredictions: [],
        searchAgentPredictions: [],
      };
    }
  }
} 